import type { CardType } from '../types/deck'

export const typeArraysToString = (card: CardType): string => {
  let output = card.superTypes.concat(card.types).join(' ')
  if (card.subTypes.length) {
    output += ' — ' + card.subTypes.join(' ')
  }
  return output
}
